import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <img 
        src={`${process.env.PUBLIC_URL}/banner.png`} 
        alt="iGames.ng - Free Online Casino Games Platform" 
        className="banner"
        width="1200"
        height="300"
      />
      <div className="header-content">
        <div className="header-text">
          <Link to="/" className="logo-link">
            <h1 className="logo">Play FREE Online Casino Games</h1>
          </Link>
          <p className="tagline">3000+ Free Slots, Table Games & More - No Download Required</p>
        </div>
        <div className="header-buttons">
          <Link to="/tips" className="header-nav-button" aria-label="Go to Tips page">
            Tips
          </Link>
          <Link to="/faqs" className="header-nav-button" aria-label="Go to FAQs page">
            FAQs
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
